export const NO_DATA_DISPLAY_NS = 'components/NodataDisplay';

export const i18n = {
  en: {
    title: 'No data to display',
    adjustFilter: 'Try to adjust filters or select a different date range',
    noBargeData:
      "Your account currently doesn't have access to data for any registered barge. Please contact support if you require access",
    contactBtn: 'Contact ADP support',
  },
};
